<template>
  <div v-if="questionList.length > 0">
    <v-subheader class="font-weight-bold">{{ group.name }}</v-subheader>
    <v-divider class="mb-3"></v-divider>
    <question-list v-for="question in questionList" :question="question" :key="question.id"></question-list>
    <v-divider class="mt-3"></v-divider>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import QuestionList from './QuestionList';

export default {
  components: {
    QuestionList
  },
  name: 'question-group-list',
  props: ['group'],
  computed: {
    ...mapGetters(['getAnswerById', 'SelectedCustomer', 'RegistrationAnswers']),
    questionList: function() {
      let questions = _.filter(this.group.questions, question => question.enabled === true && this.visible(question));

      if (_.isUndefined(this.SelectedCustomer.id)) {
        this.setRegistrationQuestionCount(questions.length);
      }

      return _.orderBy(questions, 'pivot.sort_order');
    }
  },
  methods: {
    ...mapActions(['setRegistrationQuestionCount']),
    visible: function(question) {
      if (!question.parents || question.parents.length === 0) {
        return true;
      }
      return question.parents.some(answer => {
        if (_.isUndefined(this.SelectedCustomer.id)) {
          return _.findIndex(this.RegistrationAnswers, ['answer_id', answer.id]) >= 0;
        }
        return typeof this.getAnswerById(answer.id) !== 'undefined';
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
